import { FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { Sources } from '../../shared/services/request-comments.service';
var RequestReviewModalComponent = /** @class */ (function () {
    function RequestReviewModalComponent(formBuilder) {
        this.onClose = new Subject();
        this.onReviewed = new Subject();
        this.reviewForm = formBuilder.group({
            comment: formBuilder.control(null)
        });
    }
    Object.defineProperty(RequestReviewModalComponent.prototype, "comment", {
        get: function () { return this.reviewForm.get("comment"); },
        enumerable: true,
        configurable: true
    });
    ;
    RequestReviewModalComponent.prototype.ngOnInit = function () {
    };
    RequestReviewModalComponent.prototype.close = function () {
        this.onClose.next();
    };
    RequestReviewModalComponent.prototype.completeReview = function () {
        var formData = this.reviewForm.value;
        this.onReviewed.next({
            requestId: this.request.id,
            comment: formData.comment,
            source: Sources.ReadyForReviewToReviewed
        });
    };
    return RequestReviewModalComponent;
}());
export { RequestReviewModalComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-review-modal/request-review-modal.component.ts.pre-build-optimizer.js